import React, { FC } from 'react';
import constants from '../../../../../core/constants';
import Frame from '../../../../components/Frame';
import useProfile from '../../../../hooks/useProfile';
import { BackButton } from '../../../procedures/components';
import { ProcedureWrapper } from '../../../procedures/styled';

interface IProps {
  handlerBack: any;
}

const EnrollmentSurveyView: FC<IProps> = ({ handlerBack }) => {
  const { profile } = useProfile();

  return (
    <ProcedureWrapper gap data-testid="enrollment-survey-view">
      <BackButton onClick={handlerBack} />
      <Frame
        source={`${constants.PE_URL}${constants.PE_PATH_ENCUESTA_INTENCION_MATRICULA}`}
        title="MyIframe"
      >
        <input type="hidden" name="codutpalu" value={profile.studentCode} />
      </Frame>
    </ProcedureWrapper>
  );
};

export default EnrollmentSurveyView;
